import { render, staticRenderFns } from "./FloodZone.vue?vue&type=template&id=2b4a2980&"
import script from "./FloodZone.vue?vue&type=script&lang=ts&"
export * from "./FloodZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports